import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SvgIcons from "../Icons/SvgIcons.jsx";
import "../Css/Sidebar.css";
import "../Css/Common.css";
import Content from "../utils/content.json";
import AddDeviceDialog from "./modals/AddDevice/AddDevice.jsx";

function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isTextVisible, setIsTextVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const sidebarRef = useRef(null);

  const getIconForPath = (name) => {
    switch (name) {
      case "Home":
        return <SvgIcons.Home />;
      case "Devices":
        return <SvgIcons.Devices />;
      case "Files":
        return <SvgIcons.Files />;
      case "Macros":
        return <SvgIcons.Macro />;
      case "Automations":
        return <SvgIcons.Automations />;
      case "History":
        return <SvgIcons.History />;
      case "Filament":
        return <SvgIcons.Filament />;
      case "Statistics":
        return <SvgIcons.Ststistic />;
      case "Integrations":
        return <SvgIcons.Options />;
      case "Options":
        return <SvgIcons.Options />;
      default:
        return <SvgIcons.Options />;
    }
  };

  const sidebarItems = Object.keys(Content).map((key) => {
    const formattedName = key.replace("/", "").charAt(0).toUpperCase() + key.slice(2);
    return {
      name: formattedName,
      path: Content[key][0]?.navigateTo || key,
      icon: getIconForPath(formattedName),
    };
  });

  const toggleTextVisibility = () => {
    setIsTextVisible((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (window.innerWidth <= 780 && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsTextVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const updateMainContentMargin = () => {
      const mainContent = document.querySelector(".main-content");
      if (mainContent) {
        if (window.innerWidth > 780 && isTextVisible) {
          mainContent.style.marginLeft = "13rem";
        } else {
          mainContent.style.marginLeft = "5rem";
        }
      }
    };
    updateMainContentMargin();
    window.addEventListener("resize", updateMainContentMargin);
    return () => {
      window.removeEventListener("resize", updateMainContentMargin);
    };
  }, [isTextVisible]);

  const mainItems = sidebarItems.filter(item => item.name === "Home" || item.name === "Devices");
  const libraryItems = sidebarItems.filter(item => item.name === "Files");
  const otherItems = sidebarItems.filter(item => item.name !== "Home" && item.name !== "Devices" && item.name !== "Files");

  return (
    <div
      ref={sidebarRef}
      className={`sidebar flex col ${isTextVisible ? "sidebar-open" : "sidebar-closed"}`}
    >
      <div className="sidebar-top">
        <div
          key="Sidebar"
          className={`sidebar-item flex col`}
          onClick={toggleTextVisibility}
        >
          <span className={`sidebar-logo-text${isTextVisible ? " visible" : ""}`}>nestlinker</span>
          <div className={`sidebar-icon sidebar-toggle-icon${isTextVisible ? " open" : ""}`}>
            {isTextVisible ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15 6L9 12L15 18" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M9 6L15 12L9 18" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
          </div>
        </div>

        {/* MAIN group */}
        <div className="sidebar-main-goup">

        
        <div className="sidebar-group-label fade-label sidebar-main">
          Main
        </div>
        <div className="sidebar-group-divider" />
</div>
        {mainItems.map((item) => (
          <div
            key={item.name}
            className={`sidebar-item flex ${location.pathname === item.path ? "active" : ""}`}
            onClick={() => navigate(item.path)}
          >
            <div className="sidebar-icon">{item.icon}</div>
            <div className="sidebar-text">
              <span>{item.name}</span>
            </div>
          </div>
        ))}

        {/* LIBRARY group */}
        <div className="sidebar-library-group">
        <div className="sidebar-group-label fade-label sidebar-library">
          Library
        </div>
        </div>
        {libraryItems.map((item) => (
          <div
            key={item.name}
            className={`sidebar-item flex ${location.pathname === item.path ? "active" : ""}`}
            onClick={() => navigate(item.path)}
          >
            <div className="sidebar-icon">{item.icon}</div>
            <div className="sidebar-text">
              <span>{item.name}</span>
            </div>
          </div>
        ))}

        {/* Pozostałe */}
        {otherItems.map((item) => (
          <div
            key={item.name}
            className={`sidebar-item flex ${location.pathname === item.path ? "active" : ""}`}
            onClick={() => navigate(item.path)}
          >
            <div className="sidebar-icon">{item.icon}</div>
            <div className="sidebar-text">
              <span>{item.name}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="sidebar-bot">
        <div
          className="sidebar-item flex find-devices"
          onClick={() => setIsModalOpen(true)}
        >
          <div className="sidebar-icon"><SvgIcons.Find /></div>
          <div className="sidebar-text">
            <span>Find devices</span>
          </div>
        </div>
        <div className="sidebar-item flex get-help">
          <div className="sidebar-icon"><SvgIcons.Help /></div>
          <div className="sidebar-text">
            <span>Get Help</span>
          </div>
        </div>
      </div>

      {/* AddDeviceDialog Modal */}
      <AddDeviceDialog
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
}

export default Sidebar;